import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TareaPiscinasModel } from '../../../../../models/tareas/tarea-piscinas.model';
import { MtoReactiveFormComponent } from '../../mto-reactive/mto-reactive-form.component';
import { TareasMtoPiscinasFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-tareas-mto-piscinas-form',
    standalone: false,
    templateUrl: './tareas-mto-piscinas-form.component.html',
    styleUrls: ['./tareas-mto-piscinas-form.component.scss'],
})
export class TareasMtoPiscinasFormComponent extends MtoReactiveFormComponent<TareaPiscinasModel, TareasMtoPiscinasFormDefinition> {
    constructor(
        route: ActivatedRoute,
        dashboard: DashboardService,
        fincasApi: FincasApiService,
        clientesApi: ClientesApiService,
        trabajadoresApi: TrabajadoresApiService,
        tareasApi: TareasApiService,
        router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi,
            clientesApi,
            trabajadoresApi,
            tareasApi.mtoPiscinas.PUT,
            tareasApi.mtoPiscinas.POST,
            tareasApi.mtoPiscinas.GET,
            'piscinas',
            'Actualizar Tarea Piscinas',
            'Realizar Tarea Piscinas',
            'Duplicar Tarea Piscinas',
            {
                loadingLabel: 'Cargando datos del formulario de piscinas...',
                errorContext: 'piscinas',
            },
        );
    }

    protected createFormDefinition(): TareasMtoPiscinasFormDefinition {
        return new TareasMtoPiscinasFormDefinition(this.getType(), this.model);
    }
}
